import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useChatbotContext } from '../../../hooks/ChatbotContext';
import ChatButton from '../ChatButton';
import './ChatHeader.scss';

function ChatHeader({ onClose, onCollapse, onToggleHistory, onNewChat, historyButtonRef, showLeftContent = true }) {
  const { t } = useTranslation(['chatbot']);
  const { mode } = useChatbotContext();

  // Use onCollapse if provided, otherwise fall back to onClose
  const handleCloseClick = onCollapse || onClose;

  return (
    <div className="chat-header-container">
      <div className="chat-header">
        <div className="chat-header__left">
          {showLeftContent && mode === 'study' && (
            <>
              <ChatButton
                variant="text"
                color="brand"
                onClick={onNewChat}
                icon="new"
                iconPosition="iconOnly"
                className="chat-header__new-chat-button"
                title={t('chatbot:New chat')}
              />
              <ChatButton
                ref={historyButtonRef}
                variant="text"
                color="brand"
                onClick={onToggleHistory}
                icon="replay-history"
                iconPosition="iconOnly"
                className="chat-header__history-button"
                title={t('chatbot:History')}
              />
            </>
          )}
        </div>

        <div className="chat-header__center">{/* Center badge removed */}</div>

        <div className="chat-header__right">
          {(mode === 'study' || mode === 'practice' || mode === 'teacher-tools' || mode === 'revision') && (
            <ChatButton
              variant="outlined"
              color="brand"
              onClick={handleCloseClick}
              icon="close"
              iconPosition="iconOnly"
              className="chat-header__close-button"
              title={onCollapse ? t('chatbot:Collapse') : t('chatbot:Close')}
            />
          )}
        </div>
      </div>
    </div>
  );
}

ChatHeader.propTypes = {
  onClose: PropTypes.func.isRequired,
  onCollapse: PropTypes.func,
  onNewChat: PropTypes.func,
  onToggleHistory: PropTypes.func,
  showHistory: PropTypes.bool,
  showSettings: PropTypes.bool,
  historyButtonRef: PropTypes.object,
  showLeftContent: PropTypes.bool,
};

ChatHeader.defaultProps = {
  onClose: () => {},
  onNewChat: () => {},
  onToggleHistory: () => {},
  showHistory: false,
  showSettings: false,
  historyButtonRef: null,
  showLeftContent: true,
};

export default ChatHeader;
